export enum ERole {
  Pilote = 1,
  Admin = 2,
  Utilisateur = 3,
  Root = 4,
  RootLectureSeule = 5
}
